// extracted by mini-css-extract-plugin
export default {"userContent":"page_userContent__MOMMg","editor":"page_editor__g56ia"};